import { GridColumns, GridColDef, GridRowsProp, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import { UserGroup, UserGroupDisplay } from '../enums/userGroup';

export const userViewColumns: GridColDef[] = [
  // { field: 'user_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  //   hide: true,
  // },
  {
    field: 'first_name',
    type: 'string',
    headerName: 'First Name',
    width: 175,
  },
  {
    field: 'last_name',
    type: 'string',
    headerName: 'Last Name',
    width: 175,
  },
  {
    field: 'email',
    type: 'string',
    headerName: 'Email',
    width: 275,
  },
  {
    field: 'username',
    type: 'string',
    headerName: 'Username',
    width: 200,
  },
  {
    field: 'group',
    type: 'string',
    headerName: 'User Type',
    width: 150,
    valueFormatter: (params: GridValueFormatterParams) => {
      if (!params.value) return '';
      return UserGroupDisplay[params.value as UserGroup] || params.value;
    },
  },
  {
    field: 'is_active',
    type: 'boolean',
    headerName: 'Active',
    width: 100,
  },
  {
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];

export const userAuthorizedCustomerColumns: GridColDef[] = [
  {
    field: 'company_sid',
    type: 'string',
    headerName: 'Company SID',
    width: 125,
  },
  {
    field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 250,
  },
  {
    field: 'dba_name',
    type: 'string',
    headerName: 'DBA Name',
    width: 200,
  },
  {
    field: 'representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
  },
  {
    field: 'representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
  },
  {
    field: 'representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
  },
];

export const userAuthorizedGroupColumns: GridColDef[] = [
  // { field: 'group_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  // },
  {
    field: 'group_name',
    type: 'string',
    headerName: 'Group Name',
    width: 300,
    valueFormatter: (params: GridValueFormatterParams) => {
      if (!params.value) return '';
      return UserGroupDisplay[params.value as UserGroup] || params.value;
    },
  },
];

export const userAuthorizedListAdminColumns: GridColDef[] = [
  // { field: 'listadmin_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  // },
  {
    field: 'listadmin_sid',
    type: 'string',
    headerName: 'Broker SID',
    width: 125,
  },
  {
    field: 'company_id',
    type: 'string',
    headerName: 'Company ID',
    width: 120,
    valueGetter: (params) => params.row.company_sid || '',
  },
  {
    field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 200,
  },
  {
    field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 120,
  },
  {
    field: 'naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 115,
  },
  {
    field: 'state',
    type: 'string',
    headerName: 'State',
    width: 100,
  },
  {
    field: 'postal_code',
    type: 'string',
    headerName: 'Postal Code',
    width: 125,
  },
  // { field: 'representative_name',
  //   type: 'string',
  //   headerName: 'Contact Name',
  //   width: 150,
  // },
  // { field: 'representative_title',
  //   type: 'string',
  //   headerName: 'Contact Title',
  //   width: 150,
  // },
  // { field: 'representative_email',
  //   type: 'string',
  //   headerName: 'Contact Email',
  //   width: 150,
  // },
];
